import Swiper from "swiper";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";

document.addEventListener("DOMContentLoaded", () => {
  new Swiper(".resources-list-featured__slider", {
    modules: [Pagination, Autoplay],
    slidesPerView: 1,
    spaceBetween: 30,
    autoplay: {
      delay: 7000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: "true",
      type: "bullets",
      renderBullet: function (index, className) {
        return '<span class="' + className + '">' + "<i></i>" + "<b></b>" + "</span>";
      },
    },
  });
});
